<mat-expansion-panel [expanded]="true" showToggle="false" class="matExpansion-selected">
  <mat-expansion-panel-header>
    <mat-panel-title> <b class="disable_ripple_font">PERSONAL INFORMATION </b>
		<help-text-btn class="align-help-text-btn" [helpTextId]="'InaIlp_PersonalInformation_Overview'"></help-text-btn>
    </mat-panel-title>
   
  </mat-expansion-panel-header>

  <form [formGroup]="frmPersonalInformation">
    <!--Name QAD EOE-->
    <div class="row">
      <div class="col-4">
        <mat-form-field>
          <mat-label>Name</mat-label>
          <input matInput type="string" placeholder="Name" formControlName="name" />
        </mat-form-field>
      </div>
      <div class="col-4">
        <mat-form-field>
          <mat-label>QAD</mat-label>
          <input matInput type="string" placeholder="QAD" formControlName="qad" />
        </mat-form-field>
      </div>
      <div class="col-4">
        <mat-form-field>
          <mat-label>EOE</mat-label>
          <input matInput type="string" placeholder="EOE" formControlName="eoe" />
        </mat-form-field>
      </div>
    </div>

    <!--DOB Gender MSD MSIX SSID-->
    <div class="row" style="padding-top: 30px">
      <div class="col-4">
        <mat-form-field>
          <mat-label>DOB</mat-label>
          <input matInput type="string" placeholder="DOB" formControlName="dob" />
        </mat-form-field>
      </div>
      <div class="col-4">
        <mat-label>Gender &NonBreakingSpace;</mat-label>
        <mat-radio-group aria-label name="radioGender" formControlName="radioGender" id="radioGender">
          <div class="row">
            <div class="column">
              <mat-radio-button [color]="'primary'" class="example-radio-button" value="1">Male</mat-radio-button>
            </div>
            <div class="column">
              <mat-radio-button [color]="'primary'" class="example-radio-button" value="2">Female</mat-radio-button>
            </div>
            <div class="column">
              <mat-radio-button [color]="'primary'" class="example-radio-button" value="3">Non-binary</mat-radio-button>
            </div>
          </div>
        </mat-radio-group>
      </div>
      <div class="col-4">
        <div class="row">

          <mat-form-field appearance="outline">
            <mat-label>MSD</mat-label>
            <input matInput placeholder="MSD" formControlName="msd" />
          </mat-form-field>


          <mat-form-field appearance="outline">
            <mat-label>MSIX</mat-label>
            <input matInput placeholder="MSIX" formControlName="msix" />
          </mat-form-field>



          <mat-form-field appearance="outline">
            <mat-label>SSID</mat-label>
            <input matInput placeholder="SSID" formControlName="ssid" />
          </mat-form-field>

        </div>
      </div>
    </div>

    <!--Current Address City and Current Address phone-->
    <div class="row">
      <mat-checkbox [color]="'primary'" formControlName="temporaryAddress">Temporary Address</mat-checkbox>
    </div>

    <div class="row">
      <div class="col-4 inline">
        <mat-form-field class="w-100">
          <mat-label>Current Address</mat-label>
          <input matInput type="string" placeholder="Enter Current Address" formControlName="currentAddress" />
        </mat-form-field>
		<help-text-btn class="align-help-text-btn" [helpTextId]="'InaIlp_PersonalInformation_CurrentAddress'"></help-text-btn>
      </div>
      <div class="col-4">
        <mat-form-field>
          <mat-label>City</mat-label>
          <input matInput type="string" placeholder="Enter City" formControlName="city" />
        </mat-form-field>
      </div>
      <div class="col-4">
        <mat-form-field>
          <mat-label>Current Address Phone</mat-label>
          <input matInput type="string" placeholder="Enter Current Address Phone"
            formControlName="currentAddressPhone" />
        </mat-form-field>
      </div>
    </div>

    <!-- District, School and Grade-->
    <div class="row" style="padding-top: 30px">
      <div class="col-4">
        <mat-form-field>
          <mat-label>District</mat-label>
          <input matInput type="string" placeholder="Enter the District" formControlName="district" />
        </mat-form-field>
      </div>
      <div class="col-4">
        <mat-form-field>
          <mat-label>School</mat-label>
          <input matInput type="string" placeholder="Enter the School" formControlName="school" />
        </mat-form-field>
      </div>
      <div class="col-4">
        <mat-form-field>
          <mat-label>Grade</mat-label>
          <input matInput type="string" placeholder="Enter the Grade" formControlName="grade" />
        </mat-form-field>
      </div>
    </div>
  </form>

  <div class="row" *ngIf="(action==2 || action==3) ">
    <mat-accordion>
      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title>
            Past Edit - {{this.trackHistories.inaHistory.length}}
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div *ngIf="this.trackHistories.inaHistory.length>=1">
          <app-past-edit [section]="this.section"></app-past-edit>
        </div>
      </mat-expansion-panel>
    </mat-accordion>
  </div>

</mat-expansion-panel>